import script from "./scan-schedule-settings.vue?vue&type=script&lang=ts&setup=true"
export * from "./scan-schedule-settings.vue?vue&type=script&lang=ts&setup=true"

import "./scan-schedule-settings.vue?vue&type=style&index=0&id=486eb1d4&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-486eb1d4"]])

export default __exports__